export default __webpack_public_path__ + "static/media/web_screen_engage_ptBR.cf6ee6e9.png";